import { ContentType } from '@entries/content-types'
import ContentfulFaqPageAccordion from '@entries/contentful-faq-page-accordion'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import { AccordionList } from '@ui/accordion-list'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulFaqPageList: Utils.EntryFC<
  Queries.ContentfulFaqPageListFragment
> = ({
  content: { questionsRef = [] },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <AccordionList
    {...entryInspectorProps()}
    {...fieldInspectorProps({
      fieldId: 'questionsRef',
    })}
  >
    {questionsRef.map((item, i) => (
      <Entry
        key={i}
        content={item}
        mapping={{
          [ContentType.ContentfulFaqPage]: ContentfulFaqPageAccordion,
        }}
      />
    ))}
  </AccordionList>
)

export const query = graphql`
  fragment ContentfulFaqPageList on ContentfulWrapperInbentaContentList {
    ...ContentfulEntry
    questionsRef {
      ...ContentfulFaqPageAccordion
    }
  }
`

export default withDisplayName(ContentfulFaqPageList, 'ContentfulFaqPageList')
